import { render, staticRenderFns } from "./searchRecord.vue?vue&type=template&id=9ff7bfb8&scoped=true&"
import script from "./searchRecord.vue?vue&type=script&lang=js&"
export * from "./searchRecord.vue?vue&type=script&lang=js&"
import style0 from "./searchRecord.vue?vue&type=style&index=0&id=9ff7bfb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff7bfb8",
  null
  
)

export default component.exports